import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.esm.js';
import React__default from 'react';
import PrimitiveModal from './primitives/modal.esm.js';
import AlertDialog from '../dialog/alert-dialog.esm.js';
import DialogTrigger from '../dialog/primitives/aria/dialog-trigger.esm.js';

var _excluded = ["className", "isOpen", "defaultOpen", "onOpenChange", "triggerElement", "size", "fullHeight", "portalElement", "shouldHideBackgroundOnHidden", "maxHeight", "testId", "allowOverflowModal"];
function DialogModal(_ref) {
  var className = _ref.className,
    isOpen = _ref.isOpen,
    defaultOpen = _ref.defaultOpen,
    onOpenChange = _ref.onOpenChange,
    triggerElement = _ref.triggerElement,
    size = _ref.size,
    fullHeight = _ref.fullHeight,
    portalElement = _ref.portalElement,
    shouldHideBackgroundOnHidden = _ref.shouldHideBackgroundOnHidden,
    maxHeight = _ref.maxHeight,
    testId = _ref.testId,
    allowOverflowModal = _ref.allowOverflowModal,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React__default.createElement(DialogTrigger, {
    isOpen: isOpen,
    defaultOpen: defaultOpen,
    onOpenChange: onOpenChange
  }, triggerElement, /*#__PURE__*/React__default.createElement(PrimitiveModal, {
    testId: testId,
    className: className,
    size: size,
    fullHeight: fullHeight,
    shouldHideBackgroundOnHidden: shouldHideBackgroundOnHidden,
    UNSTABLE_portalContainer: portalElement,
    maxHeight: maxHeight,
    allowOverflowModal: allowOverflowModal
  }, /*#__PURE__*/React__default.createElement(AlertDialog, _extends({}, props, {
    canShrink: !allowOverflowModal
  }))));
}

export { DialogModal as default };
//# sourceMappingURL=dialog-modal.esm.js.map
